import * as Types from '../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AttachSupportingDocumentResponseMutationVariables = Types.Exact<{
  blobFile: Types.BlobFileInput;
}>;


export type AttachSupportingDocumentResponseMutation = { __typename?: 'Mutation', uploadEcapDocument?: { __typename?: 'TFBlobResponse', blobId?: number | null, downloadLink?: string | null, fileName?: string | null, mimeType?: string | null, requiresAuthentication?: boolean | null, rolesAllowed?: string | null, insertUser?: string | null, insertTime?: string | null, updateUser?: string | null, updateTime?: string | null } | null };

export type AssociateWithBlobMutationVariables = Types.Exact<{
  blobInfo: Types.BlobInfo;
}>;


export type AssociateWithBlobMutation = { __typename?: 'Mutation', associateWithBlob?: { __typename?: 'SupportingDocumentResponse', attachmentId?: number | null, blobId?: number | null, blobPath?: string | null, fileName?: string | null, documentId?: number | null, attachmentType?: string | null, sizeInKB?: number | null } | null };

export type DeleteSupportingDocumentMutationVariables = Types.Exact<{
  attachmentId: Types.Scalars['String']['input'];
}>;


export type DeleteSupportingDocumentMutation = { __typename?: 'Mutation', deleteSupportingDocument: { __typename?: 'DeleteResponse', statusCode: number } };

export type InsertIncEcapChannelMutationVariables = Types.Exact<{
  partnerNo: Types.Scalars['String']['input'];
  companyCode: Types.Scalars['String']['input'];
  systemCode: Types.Scalars['String']['input'];
}>;


export type InsertIncEcapChannelMutation = { __typename?: 'Mutation', insertObtIncEcapChannel?: { __typename?: 'OnbPartnerChannel', id: string, partnerno: string, idpartner: number, companycode: string, invprocess: string, channeltype: string, validto: string } | null };

export type UpdateDocumentRecordMutationVariables = Types.Exact<{
  documentRecord: Types.DocumentRecordInput;
}>;


export type UpdateDocumentRecordMutation = { __typename?: 'Mutation', updateDocumentRecord?: { __typename?: 'DocumentRecord', document?: { __typename?: 'ECAPDocument', id?: number | null, documentTypeId?: number | null, documentStatusId?: number | null, companyPartnerId?: number | null, companyCode?: string | null, partnerVatCodeId?: number | null, bmwIsRetailOutlet?: boolean | null, bmwBusinessAreaId?: number | null, bmwBusinessUnitId?: number | null, bmwContactName?: string | null, bmwContactDepartment?: string | null, bmwContactTelephone?: string | null, bmwContactEmail?: string | null, currencyCodeId?: string | null, localCurrencyCodeId?: string | null, exchangeRate?: number | null, exchangeRateDate?: string | null, documentNumber?: string | null, documentDate?: string | null, orderNumber?: string | null, deliveryNumber?: string | null, deliveryDate?: string | null, documentFormatId?: number | null, processCodeId?: number | null, originalInvoiceNumber?: string | null, agreementReference?: string | null, headerText?: string | null, footerText?: string | null, grossAmount?: number | null, localCurrencyGrossAmount?: number | null, localCurrencyTaxAmount?: number | null, localCurrencyTaxableAmount?: number | null, paymentTerms?: string | null, bmwGroupPaymentRequest?: boolean | null, companyVatCodeId?: number | null, isTemplateDocument?: boolean | null, bmwCompanyCity?: string | null, bmwCompanyCountryCode?: string | null, bmwCompanyPostalCode?: string | null, bmwCompanyStreet1?: string | null, bmwCompanyStreet2?: string | null, bmwCompanyTaxId?: string | null, isOrderNumberNotRequired?: boolean | null } | null, shippingInformation?: { __typename?: 'ShippingInformation', ecDocumentShippingInfoId?: number | null, shipFromCity?: string | null, shipFromContact?: string | null, shipFromCountryCode?: string | null, shipFromCountry?: string | null, shipFromDepartment?: string | null, shipFromPostalCode?: string | null, shipFromRegionCode?: string | null, shipFromRegion?: string | null, shipFromStreet?: string | null, shipToCity?: string | null, shipToContact?: string | null, shipToCountryCode?: string | null, shipToCountry?: string | null, shipToDepartment?: string | null, shipToPostalCode?: string | null, shipToRegionCode?: string | null, shipToRegion?: string | null, shipToStreet?: string | null, shipFromName?: string | null, shipToName?: string | null } | null, supplierDetails?: { __typename?: 'SupplierDetails', documentPartnerProfileId?: number | null, bankAccountNumber?: string | null, bankBranchCode?: string | null, bankIban?: string | null, bankSwiftBicNumber?: string | null, placeOfRegistration?: string | null, managingDirector?: string | null, legalFormTypeId?: number | null, liquidationRemark?: string | null, inLiquidation?: boolean | null, hasFiscalRepresentative?: boolean | null, chairmanOfSupervisoryBoard?: string | null, companyRegistrationNumber?: string | null, companyRegistryData?: string | null, contactDepartment?: string | null, contactEmail?: string | null, contactName?: string | null, contactTelephone?: string | null, fiscalRepresentativeAddressCity?: string | null, fiscalRepresentativeAddressPostalCode?: string | null, fiscalRepresentativeAddressCountryCode?: string | null, fiscalRepresentativeAddressCountry?: string | null, fiscalRepresentativeAddressRegionCode?: string | null, fiscalRepresentativeAddressRegion?: string | null, fiscalRepresentativeAddressStreet?: string | null, fiscalRepresentativeName?: string | null, fiscalRepresentativeVatId?: string | null } | null, lineItems?: Array<{ __typename?: 'LineItems', ecDocumentDetailId?: number | null, ecDocumentId?: number | null, lineNo?: number | null, deliveryDate?: string | null, deliveryNo?: string | null, quantity?: number | null, grossAmount?: number | null, itemDescription?: string | null, netAmount?: number | null, orderNumber?: string | null, taxAmount?: number | null, taxRate?: number | null, unitPrice?: number | null }> | null, agreementHistory?: { __typename?: 'AgreementHistory', id?: number | null, agreementAcceptedDate?: string | null, companyPartnerId?: number | null } | null, documentTemplate?: { __typename?: 'DocumentTemplate', id?: number | null, templateName?: string | null } | null } | null };

export type MutateDocumentRecordMutationVariables = Types.Exact<{
  documentRecord: Types.DocumentRecordInput;
}>;


export type MutateDocumentRecordMutation = { __typename?: 'Mutation', mutateDocumentRecord?: { __typename?: 'DocumentRecord', document?: { __typename?: 'ECAPDocument', id?: number | null, documentTypeId?: number | null, documentStatusId?: number | null, companyPartnerId?: number | null, companyCode?: string | null, partnerVatCodeId?: number | null, bmwIsRetailOutlet?: boolean | null, bmwBusinessAreaId?: number | null, bmwBusinessUnitId?: number | null, bmwContactName?: string | null, bmwContactDepartment?: string | null, bmwContactTelephone?: string | null, bmwContactEmail?: string | null, currencyCodeId?: string | null, localCurrencyCodeId?: string | null, exchangeRate?: number | null, exchangeRateDate?: string | null, documentNumber?: string | null, documentDate?: string | null, orderNumber?: string | null, deliveryNumber?: string | null, deliveryDate?: string | null, documentFormatId?: number | null, processCodeId?: number | null, originalInvoiceNumber?: string | null, agreementReference?: string | null, headerText?: string | null, footerText?: string | null, grossAmount?: number | null, netAmount?: number | null, taxableAmount?: number | null, taxAmount?: number | null, localCurrencyGrossAmount?: number | null, localCurrencyTaxAmount?: number | null, localCurrencyTaxableAmount?: number | null, localCurrencyNetAmount?: number | null, paymentTerms?: string | null, bmwGroupPaymentRequest?: boolean | null, companyVatCodeId?: number | null, isTemplateDocument?: boolean | null, bmwCompanyTaxId?: string | null, bmwCompanyCity?: string | null, bmwCompanyCountryCode?: string | null, bmwCompanyPostalCode?: string | null, bmwCompanyStreet1?: string | null, bmwCompanyStreet2?: string | null, isOrderNumberNotRequired?: boolean | null } | null, shippingInformation?: { __typename?: 'ShippingInformation', ecDocumentShippingInfoId?: number | null, shipFromCity?: string | null, shipFromContact?: string | null, shipFromCountryCode?: string | null, shipFromCountry?: string | null, shipFromDepartment?: string | null, shipFromPostalCode?: string | null, shipFromRegionCode?: string | null, shipFromRegion?: string | null, shipFromStreet?: string | null, shipToCity?: string | null, shipToContact?: string | null, shipToCountryCode?: string | null, shipToCountry?: string | null, shipToDepartment?: string | null, shipToPostalCode?: string | null, shipToRegionCode?: string | null, shipToRegion?: string | null, shipToStreet?: string | null, shipToName?: string | null, shipFromName?: string | null } | null, supplierDetails?: { __typename?: 'SupplierDetails', documentPartnerProfileId?: number | null, bankAccountNumber?: string | null, bankBranchCode?: string | null, bankIban?: string | null, bankSwiftBicNumber?: string | null, placeOfRegistration?: string | null, managingDirector?: string | null, legalFormTypeId?: number | null, liquidationRemark?: string | null, inLiquidation?: boolean | null, hasFiscalRepresentative?: boolean | null, chairmanOfSupervisoryBoard?: string | null, companyRegistrationNumber?: string | null, companyRegistryData?: string | null, contactDepartment?: string | null, contactEmail?: string | null, contactName?: string | null, contactTelephone?: string | null, fiscalRepresentativeAddressCity?: string | null, fiscalRepresentativeAddressCountryCode?: string | null, fiscalRepresentativeAddressCountry?: string | null, fiscalRepresentativeAddressPostalCode?: string | null, fiscalRepresentativeAddressRegionCode?: string | null, fiscalRepresentativeAddressRegion?: string | null, fiscalRepresentativeAddressStreet?: string | null, fiscalRepresentativeName?: string | null, fiscalRepresentativeVatId?: string | null, partnerVatCode?: string | null, partnerVatCountryCode?: string | null, companyVatCode?: string | null, companyVatCountryCode?: string | null, partnerNo?: string | null, partnerName?: string | null, systemCode?: string | null, street1?: string | null, street2?: string | null, postalCode?: string | null, regionCode?: string | null, city?: string | null, countryCode?: string | null, partnerTaxId?: string | null, companyCode?: string | null, companyName?: string | null } | null, lineItems?: Array<{ __typename?: 'LineItems', ecDocumentDetailId?: number | null, ecDocumentId?: number | null, lineNo?: number | null, deliveryDate?: string | null, deliveryNo?: string | null, quantity?: number | null, grossAmount?: number | null, itemDescription?: string | null, netAmount?: number | null, orderNumber?: string | null, taxAmount?: number | null, taxRate?: number | null, unitPrice?: number | null }> | null, agreementHistory?: { __typename?: 'AgreementHistory', id?: number | null, agreementAcceptedDate?: string | null, companyPartnerId?: number | null } | null, documentTemplate?: { __typename?: 'DocumentTemplate', id?: number | null, templateName?: string | null } | null } | null };

export type UpdateEcapDocumentStatusMutationVariables = Types.Exact<{
  documentId: Types.Scalars['Float']['input'];
  documentStatusId: Types.Scalars['Float']['input'];
}>;


export type UpdateEcapDocumentStatusMutation = { __typename?: 'Mutation', updateEcapDocumentStatus?: { __typename?: 'ECAPDocument', id?: number | null, documentTypeId?: number | null, documentStatusId?: number | null, companyPartnerId?: number | null, companyCode?: string | null, partnerVatCodeId?: number | null, bmwIsRetailOutlet?: boolean | null, bmwBusinessAreaId?: number | null, bmwBusinessUnitId?: number | null, bmwContactName?: string | null, bmwContactDepartment?: string | null, bmwContactTelephone?: string | null, bmwContactEmail?: string | null, currencyCodeId?: string | null, localCurrencyCodeId?: string | null, exchangeRate?: number | null, exchangeRateDate?: string | null, documentNumber?: string | null, documentDate?: string | null, orderNumber?: string | null, deliveryNumber?: string | null, deliveryDate?: string | null, documentFormatId?: number | null, processCodeId?: number | null, originalInvoiceNumber?: string | null, agreementReference?: string | null, headerText?: string | null, footerText?: string | null, grossAmount?: number | null, localCurrencyGrossAmount?: number | null, localCurrencyTaxAmount?: number | null, localCurrencyTaxableAmount?: number | null, paymentTerms?: string | null, bmwGroupPaymentRequest?: boolean | null, companyVatCodeId?: number | null, isTemplateDocument?: boolean | null, bmwCompanyCity?: string | null, bmwCompanyCountryCode?: string | null, bmwCompanyPostalCode?: string | null, bmwCompanyStreet1?: string | null, bmwCompanyStreet2?: string | null, bmwCompanyTaxId?: string | null, isOrderNumberNotRequired?: boolean | null } | null };

export type CreatePostgresEcDocumentMutationVariables = Types.Exact<{
  documentId: Types.Scalars['Float']['input'];
}>;


export type CreatePostgresEcDocumentMutation = { __typename?: 'Mutation', createPostgresECDocument?: boolean | null };

export type DeleteBlobMutationVariables = Types.Exact<{
  blobId: Types.Scalars['Float']['input'];
  appName: Types.Scalars['String']['input'];
}>;


export type DeleteBlobMutation = { __typename?: 'Mutation', deleteBlobFile: { __typename?: 'BlobDeleteResult', blobId: number, status: number } };


export const AttachSupportingDocumentResponseDocument = gql`
    mutation AttachSupportingDocumentResponse($blobFile: BlobFileInput!) {
  uploadEcapDocument(blobFile: $blobFile) {
    blobId
    downloadLink
    fileName
    mimeType
    requiresAuthentication
    rolesAllowed
    insertUser
    insertTime
    updateUser
    updateTime
  }
}
    `;
export type AttachSupportingDocumentResponseMutationFn = Apollo.MutationFunction<AttachSupportingDocumentResponseMutation, AttachSupportingDocumentResponseMutationVariables>;

/**
 * __useAttachSupportingDocumentResponseMutation__
 *
 * To run a mutation, you first call `useAttachSupportingDocumentResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachSupportingDocumentResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachSupportingDocumentResponseMutation, { data, loading, error }] = useAttachSupportingDocumentResponseMutation({
 *   variables: {
 *      blobFile: // value for 'blobFile'
 *   },
 * });
 */
export function useAttachSupportingDocumentResponseMutation(baseOptions?: Apollo.MutationHookOptions<AttachSupportingDocumentResponseMutation, AttachSupportingDocumentResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttachSupportingDocumentResponseMutation, AttachSupportingDocumentResponseMutationVariables>(AttachSupportingDocumentResponseDocument, options);
      }
export type AttachSupportingDocumentResponseMutationHookResult = ReturnType<typeof useAttachSupportingDocumentResponseMutation>;
export type AttachSupportingDocumentResponseMutationResult = Apollo.MutationResult<AttachSupportingDocumentResponseMutation>;
export type AttachSupportingDocumentResponseMutationOptions = Apollo.BaseMutationOptions<AttachSupportingDocumentResponseMutation, AttachSupportingDocumentResponseMutationVariables>;
export const AssociateWithBlobDocument = gql`
    mutation AssociateWithBlob($blobInfo: BlobInfo!) {
  associateWithBlob(blobInfo: $blobInfo) {
    attachmentId
    blobId
    blobPath
    fileName
    documentId
    attachmentType
    sizeInKB
  }
}
    `;
export type AssociateWithBlobMutationFn = Apollo.MutationFunction<AssociateWithBlobMutation, AssociateWithBlobMutationVariables>;

/**
 * __useAssociateWithBlobMutation__
 *
 * To run a mutation, you first call `useAssociateWithBlobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateWithBlobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateWithBlobMutation, { data, loading, error }] = useAssociateWithBlobMutation({
 *   variables: {
 *      blobInfo: // value for 'blobInfo'
 *   },
 * });
 */
export function useAssociateWithBlobMutation(baseOptions?: Apollo.MutationHookOptions<AssociateWithBlobMutation, AssociateWithBlobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssociateWithBlobMutation, AssociateWithBlobMutationVariables>(AssociateWithBlobDocument, options);
      }
export type AssociateWithBlobMutationHookResult = ReturnType<typeof useAssociateWithBlobMutation>;
export type AssociateWithBlobMutationResult = Apollo.MutationResult<AssociateWithBlobMutation>;
export type AssociateWithBlobMutationOptions = Apollo.BaseMutationOptions<AssociateWithBlobMutation, AssociateWithBlobMutationVariables>;
export const DeleteSupportingDocumentDocument = gql`
    mutation DeleteSupportingDocument($attachmentId: String!) {
  deleteSupportingDocument(attachmentId: $attachmentId) {
    statusCode
  }
}
    `;
export type DeleteSupportingDocumentMutationFn = Apollo.MutationFunction<DeleteSupportingDocumentMutation, DeleteSupportingDocumentMutationVariables>;

/**
 * __useDeleteSupportingDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteSupportingDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSupportingDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSupportingDocumentMutation, { data, loading, error }] = useDeleteSupportingDocumentMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useDeleteSupportingDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSupportingDocumentMutation, DeleteSupportingDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSupportingDocumentMutation, DeleteSupportingDocumentMutationVariables>(DeleteSupportingDocumentDocument, options);
      }
export type DeleteSupportingDocumentMutationHookResult = ReturnType<typeof useDeleteSupportingDocumentMutation>;
export type DeleteSupportingDocumentMutationResult = Apollo.MutationResult<DeleteSupportingDocumentMutation>;
export type DeleteSupportingDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteSupportingDocumentMutation, DeleteSupportingDocumentMutationVariables>;
export const InsertIncEcapChannelDocument = gql`
    mutation InsertIncEcapChannel($partnerNo: String!, $companyCode: String!, $systemCode: String!) {
  insertObtIncEcapChannel(
    partnerNo: $partnerNo
    companyCode: $companyCode
    systemCode: $systemCode
  ) {
    id
    partnerno
    idpartner
    companycode
    invprocess
    channeltype
    validto
  }
}
    `;
export type InsertIncEcapChannelMutationFn = Apollo.MutationFunction<InsertIncEcapChannelMutation, InsertIncEcapChannelMutationVariables>;

/**
 * __useInsertIncEcapChannelMutation__
 *
 * To run a mutation, you first call `useInsertIncEcapChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertIncEcapChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertIncEcapChannelMutation, { data, loading, error }] = useInsertIncEcapChannelMutation({
 *   variables: {
 *      partnerNo: // value for 'partnerNo'
 *      companyCode: // value for 'companyCode'
 *      systemCode: // value for 'systemCode'
 *   },
 * });
 */
export function useInsertIncEcapChannelMutation(baseOptions?: Apollo.MutationHookOptions<InsertIncEcapChannelMutation, InsertIncEcapChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertIncEcapChannelMutation, InsertIncEcapChannelMutationVariables>(InsertIncEcapChannelDocument, options);
      }
export type InsertIncEcapChannelMutationHookResult = ReturnType<typeof useInsertIncEcapChannelMutation>;
export type InsertIncEcapChannelMutationResult = Apollo.MutationResult<InsertIncEcapChannelMutation>;
export type InsertIncEcapChannelMutationOptions = Apollo.BaseMutationOptions<InsertIncEcapChannelMutation, InsertIncEcapChannelMutationVariables>;
export const UpdateDocumentRecordDocument = gql`
    mutation updateDocumentRecord($documentRecord: DocumentRecordInput!) {
  updateDocumentRecord(documentRecord: $documentRecord) {
    document {
      id
      documentTypeId
      documentStatusId
      companyPartnerId
      companyCode
      partnerVatCodeId
      bmwIsRetailOutlet
      bmwBusinessAreaId
      bmwBusinessUnitId
      bmwContactName
      bmwContactDepartment
      bmwContactDepartment
      bmwContactTelephone
      bmwContactTelephone
      bmwContactEmail
      currencyCodeId
      localCurrencyCodeId
      exchangeRate
      exchangeRateDate
      documentNumber
      documentDate
      orderNumber
      deliveryNumber
      deliveryDate
      documentFormatId
      processCodeId
      originalInvoiceNumber
      agreementReference
      headerText
      footerText
      grossAmount
      localCurrencyGrossAmount
      localCurrencyTaxAmount
      localCurrencyTaxableAmount
      paymentTerms
      bmwGroupPaymentRequest
      companyVatCodeId
      isTemplateDocument
      bmwCompanyCity
      bmwCompanyCountryCode
      bmwCompanyPostalCode
      bmwCompanyStreet1
      bmwCompanyStreet2
      bmwCompanyTaxId
      isOrderNumberNotRequired
    }
    shippingInformation {
      ecDocumentShippingInfoId
      shipFromCity
      shipFromContact
      shipFromCountryCode
      shipFromCountry
      shipFromDepartment
      shipFromPostalCode
      shipFromRegionCode
      shipFromRegion
      shipFromStreet
      shipToCity
      shipToContact
      shipToCountryCode
      shipToCountry
      shipToDepartment
      shipToPostalCode
      shipToRegionCode
      shipToRegion
      shipToStreet
      shipFromName
      shipToName
    }
    supplierDetails {
      documentPartnerProfileId
      bankAccountNumber
      bankBranchCode
      bankIban
      bankSwiftBicNumber
      placeOfRegistration
      managingDirector
      legalFormTypeId
      liquidationRemark
      inLiquidation
      hasFiscalRepresentative
      chairmanOfSupervisoryBoard
      companyRegistrationNumber
      companyRegistryData
      contactDepartment
      contactEmail
      contactName
      contactTelephone
      fiscalRepresentativeAddressCity
      fiscalRepresentativeAddressPostalCode
      fiscalRepresentativeAddressCountryCode
      fiscalRepresentativeAddressCountry
      fiscalRepresentativeAddressRegionCode
      fiscalRepresentativeAddressRegion
      fiscalRepresentativeAddressStreet
      fiscalRepresentativeName
      fiscalRepresentativeVatId
    }
    lineItems {
      ecDocumentDetailId
      ecDocumentId
      lineNo
      deliveryDate
      deliveryNo
      quantity
      grossAmount
      itemDescription
      netAmount
      orderNumber
      taxAmount
      taxRate
      unitPrice
    }
    agreementHistory {
      id
      agreementAcceptedDate
      companyPartnerId
    }
    documentTemplate {
      id
      templateName
    }
  }
}
    `;
export type UpdateDocumentRecordMutationFn = Apollo.MutationFunction<UpdateDocumentRecordMutation, UpdateDocumentRecordMutationVariables>;

/**
 * __useUpdateDocumentRecordMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentRecordMutation, { data, loading, error }] = useUpdateDocumentRecordMutation({
 *   variables: {
 *      documentRecord: // value for 'documentRecord'
 *   },
 * });
 */
export function useUpdateDocumentRecordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentRecordMutation, UpdateDocumentRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentRecordMutation, UpdateDocumentRecordMutationVariables>(UpdateDocumentRecordDocument, options);
      }
export type UpdateDocumentRecordMutationHookResult = ReturnType<typeof useUpdateDocumentRecordMutation>;
export type UpdateDocumentRecordMutationResult = Apollo.MutationResult<UpdateDocumentRecordMutation>;
export type UpdateDocumentRecordMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentRecordMutation, UpdateDocumentRecordMutationVariables>;
export const MutateDocumentRecordDocument = gql`
    mutation mutateDocumentRecord($documentRecord: DocumentRecordInput!) {
  mutateDocumentRecord(documentRecord: $documentRecord) {
    document {
      id
      documentTypeId
      documentStatusId
      companyPartnerId
      companyCode
      partnerVatCodeId
      bmwIsRetailOutlet
      bmwBusinessAreaId
      bmwBusinessUnitId
      bmwContactName
      bmwContactDepartment
      bmwContactDepartment
      bmwContactTelephone
      bmwContactTelephone
      bmwContactEmail
      currencyCodeId
      localCurrencyCodeId
      exchangeRate
      exchangeRateDate
      documentNumber
      documentDate
      orderNumber
      deliveryNumber
      deliveryDate
      documentFormatId
      processCodeId
      originalInvoiceNumber
      agreementReference
      headerText
      footerText
      grossAmount
      netAmount
      taxableAmount
      taxAmount
      localCurrencyGrossAmount
      localCurrencyTaxAmount
      localCurrencyTaxableAmount
      localCurrencyNetAmount
      paymentTerms
      bmwGroupPaymentRequest
      companyVatCodeId
      isTemplateDocument
      bmwCompanyTaxId
      bmwCompanyCity
      bmwCompanyCountryCode
      bmwCompanyPostalCode
      bmwCompanyStreet1
      bmwCompanyStreet2
      isOrderNumberNotRequired
    }
    shippingInformation {
      ecDocumentShippingInfoId
      shipFromCity
      shipFromContact
      shipFromCountryCode
      shipFromCountry
      shipFromDepartment
      shipFromPostalCode
      shipFromRegionCode
      shipFromRegion
      shipFromStreet
      shipToCity
      shipToContact
      shipToCountryCode
      shipToCountry
      shipToDepartment
      shipToPostalCode
      shipToRegionCode
      shipToRegion
      shipToStreet
      shipToName
      shipFromName
    }
    supplierDetails {
      documentPartnerProfileId
      bankAccountNumber
      bankBranchCode
      bankIban
      bankSwiftBicNumber
      placeOfRegistration
      managingDirector
      legalFormTypeId
      liquidationRemark
      inLiquidation
      hasFiscalRepresentative
      chairmanOfSupervisoryBoard
      companyRegistrationNumber
      companyRegistryData
      contactDepartment
      contactEmail
      contactName
      contactTelephone
      fiscalRepresentativeAddressCity
      fiscalRepresentativeAddressCountryCode
      fiscalRepresentativeAddressCountry
      fiscalRepresentativeAddressPostalCode
      fiscalRepresentativeAddressRegionCode
      fiscalRepresentativeAddressRegion
      fiscalRepresentativeAddressStreet
      fiscalRepresentativeName
      fiscalRepresentativeVatId
      partnerVatCode
      partnerVatCountryCode
      companyVatCode
      companyVatCountryCode
      partnerNo
      partnerName
      systemCode
      street1
      street2
      postalCode
      regionCode
      city
      countryCode
      partnerTaxId
      companyCode
      companyName
    }
    lineItems {
      ecDocumentDetailId
      ecDocumentId
      lineNo
      deliveryDate
      deliveryNo
      quantity
      grossAmount
      itemDescription
      netAmount
      orderNumber
      taxAmount
      taxRate
      unitPrice
    }
    agreementHistory {
      id
      agreementAcceptedDate
      companyPartnerId
    }
    documentTemplate {
      id
      templateName
    }
  }
}
    `;
export type MutateDocumentRecordMutationFn = Apollo.MutationFunction<MutateDocumentRecordMutation, MutateDocumentRecordMutationVariables>;

/**
 * __useMutateDocumentRecordMutation__
 *
 * To run a mutation, you first call `useMutateDocumentRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateDocumentRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateDocumentRecordMutation, { data, loading, error }] = useMutateDocumentRecordMutation({
 *   variables: {
 *      documentRecord: // value for 'documentRecord'
 *   },
 * });
 */
export function useMutateDocumentRecordMutation(baseOptions?: Apollo.MutationHookOptions<MutateDocumentRecordMutation, MutateDocumentRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateDocumentRecordMutation, MutateDocumentRecordMutationVariables>(MutateDocumentRecordDocument, options);
      }
export type MutateDocumentRecordMutationHookResult = ReturnType<typeof useMutateDocumentRecordMutation>;
export type MutateDocumentRecordMutationResult = Apollo.MutationResult<MutateDocumentRecordMutation>;
export type MutateDocumentRecordMutationOptions = Apollo.BaseMutationOptions<MutateDocumentRecordMutation, MutateDocumentRecordMutationVariables>;
export const UpdateEcapDocumentStatusDocument = gql`
    mutation updateEcapDocumentStatus($documentId: Float!, $documentStatusId: Float!) {
  updateEcapDocumentStatus(
    documentId: $documentId
    documentStatusId: $documentStatusId
  ) {
    id
    documentTypeId
    documentStatusId
    companyPartnerId
    companyCode
    partnerVatCodeId
    bmwIsRetailOutlet
    bmwBusinessAreaId
    bmwBusinessUnitId
    bmwContactName
    bmwContactDepartment
    bmwContactDepartment
    bmwContactTelephone
    bmwContactTelephone
    bmwContactEmail
    currencyCodeId
    localCurrencyCodeId
    exchangeRate
    exchangeRateDate
    documentNumber
    documentDate
    orderNumber
    deliveryNumber
    deliveryDate
    documentFormatId
    processCodeId
    originalInvoiceNumber
    agreementReference
    headerText
    footerText
    grossAmount
    localCurrencyGrossAmount
    localCurrencyTaxAmount
    localCurrencyTaxableAmount
    paymentTerms
    bmwGroupPaymentRequest
    companyVatCodeId
    isTemplateDocument
    bmwCompanyCity
    bmwCompanyCountryCode
    bmwCompanyPostalCode
    bmwCompanyStreet1
    bmwCompanyStreet2
    bmwCompanyTaxId
    isOrderNumberNotRequired
  }
}
    `;
export type UpdateEcapDocumentStatusMutationFn = Apollo.MutationFunction<UpdateEcapDocumentStatusMutation, UpdateEcapDocumentStatusMutationVariables>;

/**
 * __useUpdateEcapDocumentStatusMutation__
 *
 * To run a mutation, you first call `useUpdateEcapDocumentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEcapDocumentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEcapDocumentStatusMutation, { data, loading, error }] = useUpdateEcapDocumentStatusMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      documentStatusId: // value for 'documentStatusId'
 *   },
 * });
 */
export function useUpdateEcapDocumentStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEcapDocumentStatusMutation, UpdateEcapDocumentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEcapDocumentStatusMutation, UpdateEcapDocumentStatusMutationVariables>(UpdateEcapDocumentStatusDocument, options);
      }
export type UpdateEcapDocumentStatusMutationHookResult = ReturnType<typeof useUpdateEcapDocumentStatusMutation>;
export type UpdateEcapDocumentStatusMutationResult = Apollo.MutationResult<UpdateEcapDocumentStatusMutation>;
export type UpdateEcapDocumentStatusMutationOptions = Apollo.BaseMutationOptions<UpdateEcapDocumentStatusMutation, UpdateEcapDocumentStatusMutationVariables>;
export const CreatePostgresEcDocumentDocument = gql`
    mutation createPostgresECDocument($documentId: Float!) {
  createPostgresECDocument(documentId: $documentId)
}
    `;
export type CreatePostgresEcDocumentMutationFn = Apollo.MutationFunction<CreatePostgresEcDocumentMutation, CreatePostgresEcDocumentMutationVariables>;

/**
 * __useCreatePostgresEcDocumentMutation__
 *
 * To run a mutation, you first call `useCreatePostgresEcDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostgresEcDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostgresEcDocumentMutation, { data, loading, error }] = useCreatePostgresEcDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useCreatePostgresEcDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePostgresEcDocumentMutation, CreatePostgresEcDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePostgresEcDocumentMutation, CreatePostgresEcDocumentMutationVariables>(CreatePostgresEcDocumentDocument, options);
      }
export type CreatePostgresEcDocumentMutationHookResult = ReturnType<typeof useCreatePostgresEcDocumentMutation>;
export type CreatePostgresEcDocumentMutationResult = Apollo.MutationResult<CreatePostgresEcDocumentMutation>;
export type CreatePostgresEcDocumentMutationOptions = Apollo.BaseMutationOptions<CreatePostgresEcDocumentMutation, CreatePostgresEcDocumentMutationVariables>;
export const DeleteBlobDocument = gql`
    mutation DeleteBlob($blobId: Float!, $appName: String!) {
  deleteBlobFile(blobId: $blobId, appName: $appName) {
    blobId
    status
  }
}
    `;
export type DeleteBlobMutationFn = Apollo.MutationFunction<DeleteBlobMutation, DeleteBlobMutationVariables>;

/**
 * __useDeleteBlobMutation__
 *
 * To run a mutation, you first call `useDeleteBlobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBlobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBlobMutation, { data, loading, error }] = useDeleteBlobMutation({
 *   variables: {
 *      blobId: // value for 'blobId'
 *      appName: // value for 'appName'
 *   },
 * });
 */
export function useDeleteBlobMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBlobMutation, DeleteBlobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBlobMutation, DeleteBlobMutationVariables>(DeleteBlobDocument, options);
      }
export type DeleteBlobMutationHookResult = ReturnType<typeof useDeleteBlobMutation>;
export type DeleteBlobMutationResult = Apollo.MutationResult<DeleteBlobMutation>;
export type DeleteBlobMutationOptions = Apollo.BaseMutationOptions<DeleteBlobMutation, DeleteBlobMutationVariables>;